
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="font-sora font-bold text-4xl md:text-5xl text-navy mb-6">
              Terms of Service
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Please read these terms carefully before using our website and services.
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <div className="bg-gray-50 rounded-lg p-8 mb-8">
              <p className="text-gray-600 mb-4">
                <strong>Last updated:</strong> December 2024
              </p>
              <p className="text-gray-600">
                <strong>Effective date:</strong> December 2024
              </p>
            </div>

            <section className="mb-12">
              <h2 className="font-sora font-bold text-2xl text-navy mb-6">1. Acceptance of Terms</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                By accessing and using henryadebisi.com (the "Website"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="font-sora font-bold text-2xl text-navy mb-6">2. Use License</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Permission is granted to temporarily download one copy of the materials on Henry Adebisi's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>modify or copy the materials</li>
                <li>use the materials for any commercial purpose or for any public display</li>
                <li>attempt to reverse engineer any software contained on the website</li>
                <li>remove any copyright or other proprietary notations from the materials</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="font-sora font-bold text-2xl text-navy mb-6">3. Professional Services</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                The information provided on this website regarding finance, strategy, and business consulting is for informational purposes only. Any professional services or consulting arrangements will be governed by separate written agreements.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="font-sora font-bold text-2xl text-navy mb-6">4. Disclaimer</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                The materials on Henry Adebisi's website are provided on an 'as is' basis. Henry Adebisi makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="font-sora font-bold text-2xl text-navy mb-6">5. Limitations</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                In no event shall Henry Adebisi or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Henry Adebisi's website, even if Henry Adebisi or an authorized representative has been notified orally or in writing of the possibility of such damage.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="font-sora font-bold text-2xl text-navy mb-6">6. Accuracy of Materials</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                The materials appearing on Henry Adebisi's website could include technical, typographical, or photographic errors. Henry Adebisi does not warrant that any of the materials on its website are accurate, complete, or current.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="font-sora font-bold text-2xl text-navy mb-6">7. Links</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Henry Adebisi has not reviewed all of the sites linked to our website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Henry Adebisi of the site.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="font-sora font-bold text-2xl text-navy mb-6">8. Modifications</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Henry Adebisi may revise these terms of service for its website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="font-sora font-bold text-2xl text-navy mb-6">9. Governing Law</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                These terms and conditions are governed by and construed in accordance with the laws of the United Kingdom and you irrevocably submit to the exclusive jurisdiction of the courts in that state or location.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="font-sora font-bold text-2xl text-navy mb-6">10. Contact Information</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <div className="bg-gray-50 rounded-lg p-6">
                <p className="text-gray-700">
                  <strong>Email:</strong> henry@afristakes.com<br />
                  <strong>Website:</strong> henryadebisi.com
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
